import {Component} from '@angular/core';
import * as moment from 'moment';
import {LoanApplicationService} from '../../loan-application.service';

@Component({
  selector: 'bb-birthdate',
  templateUrl: './birthdate.component.html',
  styleUrls: ['./birthdate.component.scss'],
})
export class BirthdateComponent {
  personal_info = this.loan.form.get('personal_info');
  invalid = this.personal_info.get('birthday').valueChanges
    .startWith(null)
    .map(() => this.personal_info.get('birthday').invalid);

  // Birthdate must be limited to 21-59 years old
  maxDate = moment().subtract(21, 'years').format('YYYY-MM-DD');
  minDate = moment().subtract(59, 'years').format('YYYY-MM-DD');

  constructor(public loan: LoanApplicationService) {
  }

}
